import { __extends } from "tslib";
import { StartStreamProcessorRequest, StartStreamProcessorResponse } from "../models/index";
import { deserializeAws_json1_1StartStreamProcessorCommand, serializeAws_json1_1StartStreamProcessorCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartStreamProcessorCommand = /** @class */ (function (_super) {
    __extends(StartStreamProcessorCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartStreamProcessorCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartStreamProcessorCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: StartStreamProcessorRequest.filterSensitiveLog,
            outputFilterSensitiveLog: StartStreamProcessorResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartStreamProcessorCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartStreamProcessorCommand(input, context);
    };
    StartStreamProcessorCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartStreamProcessorCommand(output, context);
    };
    return StartStreamProcessorCommand;
}($Command));
export { StartStreamProcessorCommand };
//# sourceMappingURL=StartStreamProcessorCommand.js.map